import React, { Component } from 'react';
import {
	TextField,
} from '@material-ui/core';
import { hasFeature } from '../index';

class ButtonWithPermissions extends Component {
	render() {
		const props = { ...this.props };
		if (hasFeature(this.props) === false) {
			props.disabled = true;
		}

		return (<TextField {...props} />);
	}
}

export default ButtonWithPermissions;



// WEBPACK FOOTER //
// ./src/components/Features/components/TextField.js